import { remStyleSheet, toRem, remStyle, toPx } from '@max/leez-style-util';
const isMRN = false;
const config = {
    enabled: true,
    designWidth: 750
};
export const _remStyle = (style) => {
    return remStyle(style, config);
};
export const _remStyleSheet = (styleSheet) => {
    return remStyleSheet(styleSheet, config);
};
export const _toRem = (pxV) => toRem(pxV, config);
export const _toPx = (pxV) => toPx(pxV, config);
export const getTabTheme = (headBgColorType) => {
    const styleMap = {
        light: {
            headBgColor: 'rgba(255,255,255,0.40)',
            textDefaultColor: '#222222'
        },
        dark: {
            headBgColor: 'rgba(0,0,0,0.20)',
            textDefaultColor: '#FFFFFF'
        }
    };
    return styleMap[headBgColorType];
};
